import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { URLInput } from '@wordpress/block-editor';
import { IconButton } from '@wordpress/components';

registerBlockType( 'gma-wpblocks/donate-crypto-block', {
    title: 'Donate Crypto',
    icon: 'share-alt',
    category: 'common',
    attributes: {
            url: {
                type: 'string',
                source: 'attribute',
                attribute: 'href',
                selector: 'a',
                placeholder: 'https://commerce.coinbase.com/checkout/db3b66a9-80b5-44c0-b62a-69b58c5f37e3',
            },
        },
    edit: props => {
    	
    	const { className, isSelected, setAttributes, attributes: { url } } = props;

    	return(
    		
    		<div>
	              <p>Add commerce.coinbase.com payment URL here:
	              <br></br>
	              <span class="description-block-text">For example: https://commerce.coinbase.com/checkout/db3b66a9-80b5-44c0-b62a-69b58c5f37e3</span>
	              </p>

	              <script src="https://commerce.coinbase.com/v1/checkout.js?version=201807"></script>

	              <form
	                className="blocks-format-toolbar__link-modal-line blocks-format-toolbar__link-modal-line"
	                onSubmit={ event => event.preventDefault() }
	              >
                  <URLInput
                    className="url"
                    value={ url }
                    onChange={ url => setAttributes( { url } ) }
                  />
                <IconButton
                  icon="editor-break"
                  label={ __( 'Apply', 'gma_donate_crypto' ) }
                  type="submit"
                />
              </form>

			</div>
    	
    	);
    
    },
    save: props => { 

    	const { attributes: { url } } = props;
    	
      return(
			
        <div>
          <a class="donate-with-crypto" href={ url }> Donate with Crypto </a>
          <script src="https://commerce.coinbase.com/v1/checkout.js?version=201807"></script>
        </div>
    	);
    },
} );